// extracted by mini-css-extract-plugin
module.exports = {"parent":"CustomDropdown_parent__1eUTb","item":"CustomDropdown_item__1tYFX"};